import React, { Component } from 'react';
import { Link } from 'react-router';

export default class PhotoGallery extends Component {

  render() {
    const { } = this.props;

    let galleryItems = [

    	{ "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_live_01_cropped_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_live_01_Cropped.jpg",
	    	"alt_text": "Moose Almighty performing live at the Conor Byrne Pub in Seattle, WA"
	    },
	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_live_02_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_live_02.jpg",
	    	"alt_text": "Moose Almighty performing live at Nectar Lounge in Seattle, WA"
	    },  
	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_02_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_02.jpg",
	    	"alt_text": "Group shot of the band Moose Almighty"
	    },
	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_01_square_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_01_square.jpg",
	    	"alt_text": "Group shot of the band Moose Almighty"
	    },
	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_01_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_01.jpg",
	    // 	"alt_text": "Group shot of the band Moose Almighty"
	    // },
	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_03_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_03.jpg",
	    	"alt_text": "Group shot of the band Moose Almighty"
	    },
	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_04_square_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_04_square.jpg",
	    	"alt_text": "Group shot of the band Moose Almighty"
	    },
	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_04_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit_2022/moose_almighty_2022_press_04.jpg",
	    // 	"alt_text": "Group shot of the band Moose Almighty"
	    // },

    	// OLD PRESS KIT PHOTOS
    	{ "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_group_photo_01_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_group_photo_01_HQ.jpg",
	    	"alt_text": "Group shot of the band Moose Almighty"
	    },
	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_group_photo_01_square_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_group_photo_01_square_HQ.jpg",
	    	"alt_text": "Group shot of the band Moose Almighty"
	    },
	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_group_photo_02_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_group_photo_02_HQ.jpg",
	    	"alt_text": "Group shot of the band Moose Almighty"
	    },

	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_01_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_01_HQ.jpg",
	    	"alt_text": "Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    },

	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_02_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_02_HQ.jpg",
	    	"alt_text": "Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    },

	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_03_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_03_HQ.jpg",
	    // 	"alt_text": "Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    // },

	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_04_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_04_HQ.jpg",
	    	"alt_text": "Aaron Mitchell and Chris Young of Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    },

	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_05_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_05_HQ.jpg",
	    	"alt_text": "Aaron Mitchell and Chris Young of Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    },

	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_06_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_06_HQ.jpg",
	    	"alt_text": "Daniel Underkofler of Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    },

	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_07_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_07_HQ.jpg",
	    	"alt_text": "Chris Young of Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    },

	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_08_preview.jpg", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/moose_almighty_press_live_shot_08_HQ.jpg",
	    	"alt_text": "Kevin Shoop of Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    },




	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Full_Band_Central_Saloon_Seattle_01_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Full_Band_Central_Saloon_Seattle_01.jpg",
	    // 	"alt_text": "Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    // },
	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Full_Band_Central_Saloon_Seattle_02_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Full_Band_Central_Saloon_Seattle_02.jpg",
	    // 	"alt_text": "Moose Almighty performing live at the Central Saloon in Seattle, WA"
	    // },
	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Full_Band_Sunset_Tavern_Seattle_01_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Full_Band_Sunset_Tavern_Seattle_01.jpg",
	    // 	"alt_text": "Moose Almighty performing live at the Sunset Tavern in Seattle, WA"
	    // },
	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Full_Band_Sunset_Tavern_Seattle_02_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Full_Band_Sunset_Tavern_Seattle_02.jpg",
	    // 	"alt_text": "Moose Almighty performing live at the Sunset Tavern in Seattle, WA"
	    // },
	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Group_Shot_01_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Group_Shot_01.jpg",
	    // 	"alt_text": "Moose Almighty group photo"
	    // },
	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Group_Shot_01_square_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Group_Shot_01_square.jpg",
	    // 	"alt_text": "Moose Almighty group photo"
	    // },
	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Group_Shot_02_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_Group_Shot_02.jpg",
	    // // 	"alt_text": "Moose Almighty group photo"
	    // },
	    // { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_portrait_Dan_Underkofler_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_portrait_Dan_Underkofler.jpg",
	    // 	"alt_text": "Dan Underkofler of Moose Almighty"
	    // },
	    //  { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_portrait_Aaron_Mitchell_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_portrait_Aaron_Mitchell.jpg",
	    // 	"alt_text": "Aaron Mitchell of Moose Almighty"
	    // },
	    //  { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_portrait_Chris_Young_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_portrait_Chris_Young.jpg",
	    // 	"alt_text": "Chris Young of Moose Almighty"
	    // },
	    //  { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_portrait_Kevin_Shoop_preview.jpg", 
	    // 	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_portrait_Kevin_Shoop.jpg",
	    // 	"alt_text": "Kevin Shoop of Moose Almighty"
	    // },
	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_logo_color_preview.png", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_logo_color.png",
	    	"alt_text": "Moose Almighty Logo"
	    },
	    { "photo_preview":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_logo_white_preview.png", 
	    	"photo_full":"https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/press_kit/Moose_Almighty_logo_white.png",
	    	"alt_text": "Moose Almighty Logo"
	    }, 
		]

    let gallery = galleryItems.map(photo => {
    	return (
    		<div className="gallery__image">
    			<a target="_blank" href={photo.photo_full}>
	    		  <img 
	    		  	src={photo.photo_preview} 
	    		   	alt={photo.alt_text} 
	    		   />
    		   </a>
    		  
    		</div>
    	)
    });

    return (
      <div className="PhotoGallery">
      	{gallery}
      </div>    
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/PhotoGallery/PhotoGallery.js